import { render } from "./TreinadoresLista.vue?vue&type=template&id=57c94cb4"
import script from "./TreinadoresLista.vue?vue&type=script&lang=js"
export * from "./TreinadoresLista.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__